import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  align-self: stretch;
  border-left: 4px dashed ${p => p.theme.colorContentBackground};
  background: ${p => p.theme.colorTicketBackground};
`;

const Wrapper = () => {
  return /*#__PURE__*/React.createElement(StyledWrapper, null);
};

export default Wrapper;